<onsip-signup-common-layout>
  <div class="left-content">
    <div class="onsip-signup-title select-domain">
      {{ "ONSIP_I18N.CREATE_YOUR_DOMAIN_NAME" | translate }}
    </div>
    <div class="onsip-signup-headline">
      {{
        "ONSIP_I18N.THIS_CAN_BE_THE_NAME_OF_YOUR_COMPANY_OR_ANYTHING_YOU_LIKE_AS_LONG_AS_ITS_NOT_ALREADY_IN_USE_IT_WILL_BE_USED_FOR_YOUR_TEAM_PAGE_URL_AND_YOUR_SIP_ADDRESS"
          | translate
      }}
    </div>

    <form (ngSubmit)="next()">
      <div class="domain-field">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="onsip-outlined-form">
          <input #formfield matInput autofocus type="text" [formControl]="domainFormControl" />
          <mat-error>{{ showDomainErrors() }}</mat-error>
        </mat-form-field>
        <div class="domain-suffix" matSuffix>.onsip.com</div>
      </div>
      <button
        class="domain-check-availability"
        mat-button
        type="submit"
        (click)="submitted = 'check'"
        color="primary"
      >
        <mat-icon>done_all</mat-icon>
        <span class="check-available-text">{{ "ONSIP_I18N.CHECK_AVAILABILITY" | translate }}</span>
      </button>
      <div class="signup-button-container">
        <button mat-flat-button type="submit" (click)="submitted = 'next'" color="primary">
          {{ "ONSIP_I18N.NEXT" | translate }}
        </button>
      </div>
    </form>
  </div>

  <div class="right-content">
    <img class="domain-image" [src]="'resources/img/signup/domain.svg'" alt="Domain Image" />
  </div>
</onsip-signup-common-layout>
